<template>
  <div id="btnPackageMenu">
    <v-menu
      v-model="menu"
      offset-x
      min-width="700px"
      close-on-click
      :close-on-content-click="false"
      attach="#btnPackageMenu"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          small
          v-on="on"
        >
          Додати Пакет
        </v-btn>
      </template>
      <v-card>
        <v-card-text>
          <PackageSelect
            v-model="packageSelect"
            required
            @input="onSelect"
          />
          <v-row>
            <v-col xs6>
              <DecimalEditor
                v-model="amount"
                :disabled="useVAT === useVatTypes.WITH_VAT.label"
                label="Сумма"
                scale="2"
                :hide-details="false"
                class="mr-1"
                :error-messages="$v.amount.$error ? errors.ONLY_POSITIVE : []"
                @input="$v.amount.$touch()"
              />
            </v-col>
            <v-col xs6>
              <DecimalEditor
                v-model="amountWithVAT"
                :disabled="useVAT === useVatTypes.WITHOUT_VAT.label"
                label="Сумма з ПДВ"
                scale="2"
                :hide-details="false"
                class="ml-1"
                :error-messages="
                  $v.amountWithVAT.$error ? errors.ONLY_POSITIVE : []
                "
                @input="$v.amountWithVAT.$touch()"
              />
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />

          <v-btn
            v-if="useVAT !== useVatTypes.BOTH_VAT.label"
            :disabled="selected === null"
            color="primary"
            text
            @click="ok"
          >
            {{ useVAT === useVatTypes.WITH_VAT.label ? "З ПДВ" : "Без ПДВ" }}
          </v-btn>

          <v-btn
            v-if="useVAT === useVatTypes.BOTH_VAT.label"
            :disabled="selected === null"
            color="primary"
            text
            @click="ok(false)"
          >
            Без ПДВ
          </v-btn>

          <v-btn
            v-if="useVAT === useVatTypes.BOTH_VAT.label"
            :disabled="selected === null"
            color="primary"
            text
            @click="ok(true)"
          >
            З ПДВ
          </v-btn>

          <v-btn
            text
            @click="menu = false"
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import PackageSelect from "../../catalogs/payment-packages/PackageSelect.vue";
import DecimalEditor from "../../../components/DecimalEditor.vue";
import * as packagesApi from "../../../backend/packagesApi.js";
import { ERRORS } from "@/helpers";
import { minValue } from "vuelidate/lib/validators";
import useVatTypes from "../../../helpers/useVatTypes.js";

export default {
  components: {
    DecimalEditor,
    PackageSelect,
  },
  data: () => ({
    menu: false,
    selected: null,
    amount: 0,
    amountWithVAT: 0,
    useVAT: null,
    packageSelect: null,
  }),

  validations: {
    amount: {
      minValue: minValue(0),
    },
    amountWithVAT: {
      minValue: minValue(0),
    },
  },
  computed: {
    errors() {
      return {
        ONLY_POSITIVE: [ERRORS.ONLY_POSITIVE],
      };
    },
    useVatTypes(){
      return useVatTypes;
    },
  },
  methods: {
    async onSelect() {
      if (this.packageSelect?.id) {
        this.selected = await packagesApi.getPackage(this.packageSelect.id);
        this.useVAT = this.selected.useVAT;
        this.amount = this.selected.amount;
        this.amountWithVAT = this.selected.amountWithVAT;
        this.selected.id = this.packageSelect.id;
      }
    },
    ok(withVAT) {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.$emit("input", {
        id: this.selected.id,
        type: "package",
        title: this.selected.title,
        amount:
          this.useVAT === this.useVatTypes.BOTH_VAT.label
            ? withVAT
              ? this.amountWithVAT
              : this.amount
            : this.useVAT === this.useVatTypes.WITH_VAT.label
              ? this.amountWithVAT
              : this.amount,
      });
      this.cancel();
    },
    cancel() {
      this.selected = null;
      this.amount = 0;
      this.amountWithVAT = 0;
      this.useVAT = this.useVatTypes.BOTH_VAT.label;
      this.menu = false;
      this.packageSelect = null;
    },
  },
};
</script>
